import { jsx as _jsx } from "react/jsx-runtime";
import { HcSelect } from '@hotmart-org-ca/cosmos-web/dist/react/hc-select';
import { SelectItem } from './item';
export function Select({ onChange, children, docked = true, clearable = false, placeholder, autocomplete = 'off', size = 'medium', className }) {
    function handleChange(event) {
        onChange(event.detail.value);
    }
    return (_jsx(HcSelect, { size: size, docked: docked, clearable: clearable, onChangeItem: handleChange, autocomplete: autocomplete, placeholder: placeholder, className: className, children: children }));
}
Select.Item = SelectItem;
